import { Close } from '@mui/icons-material';
import { AppBar, Stack, Toolbar, Typography } from '@mui/material';

const styles = {
    appBar: {
        backgroundColor: '#002394',
        color: 'white',
        height: '64px',
        borderRadius: '8px 8px 0px 0px !important',
        padding: '0px !important',
    },
    typography: {
        width: '98%',
        color: 'white',
    },
    closeButtonContainer: {
        cursor: 'pointer',
        height: '32px',
        paddingInline: '8px',
    },
    closeIcon: {
        color: '#0000008F',
        fontSize: 32,
    },
};

const ModalHeader = ({ title = 'New Customer', onClose, isLoading = false }) => {
    return (
        <AppBar color="secondary" variant="elevation" sx={styles.appBar}>
            <Toolbar
                variant="regular"
                style={{
                    padding: '0px 16px',
                }}
            >
                <Typography variant="h6" sx={styles.typography}>
                    {title}
                </Typography>
                <Stack direction="row" spacing={0}>
                    <div
                        onClick={isLoading ? undefined : onClose}
                        style={{
                            ...styles.closeButtonContainer,
                            cursor: isLoading ? 'not-allowed' : 'pointer',
                            opacity: isLoading ? 0.5 : 1,
                        }}
                    >
                        <Close style={styles.closeIcon} />
                    </div>
                </Stack>
            </Toolbar>
        </AppBar>
    );
};

export default ModalHeader;
